(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
  constructor(){super()}
  connectedCallback(){
    this.header=document.querySelector('.section-header');
    if(!this.header) return;
    this.headerIsAlwaysSticky=this.getAttribute('data-sticky-type')==='always'||this.getAttribute('data-sticky-type')==='reduce-logo-size';
    this.headerBounds={};
    this.setHeaderHeight();
    window.matchMedia('(max-width:990px)').addEventListener('change',this.setHeaderHeight.bind(this));
    if(this.headerIsAlwaysSticky) this.header.classList.add('shopify-section-header-sticky');
    this.currentScrollTop=0;
    this.preventReveal=false;
    this.onScrollHandler=this.onScroll.bind(this);
    window.addEventListener('scroll',this.onScrollHandler,{passive:true});
    this.createObserver();
  }
  setHeaderHeight(){
    if(this.header) document.documentElement.style.setProperty('--header-height', this.header.offsetHeight + 'px');
  }
  disconnectedCallback(){ window.removeEventListener('scroll', this.onScrollHandler); }
  createObserver(){
    const o=new IntersectionObserver((e,ob)=>{ this.headerBounds=e[0].intersectionRect; ob.disconnect(); });
    o.observe(this.header);
  }
  onScroll(){
    const s=window.pageYOffset||document.documentElement.scrollTop;
    if(s>this.currentScrollTop && s>(this.headerBounds.bottom||80)){
      this.header.classList.add('scrolled-past-header'); this.hide();
    } else if(s<this.currentScrollTop && s>(this.headerBounds.bottom||80)){
      this.header.classList.add('scrolled-past-header'); this.reveal();
    } else if(s<=(this.headerBounds.top||0)){
      this.header.classList.remove('scrolled-past-header'); this.reset();
    }
    this.currentScrollTop=s;
  }
  hide(){
    if(this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-hidden','shopify-section-header-sticky');
  }
  reveal(){
    if(this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-sticky','animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }
  reset(){
    if(this.headerIsAlwaysSticky) return;
    this.header.classList.remove('shopify-section-header-hidden','shopify-section-header-sticky','animate');
  }
}
customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
